import { lazyWithRetry } from 'components/lazyUtil.js'

const RequestDocs = lazyWithRetry(() => import('../../users/sections/uploadRiderDocs'))

// IMPORTANT //
// In Future: whenever new route path is added ensure to update "validPaths" in /server/validRoutes.js
const routes = [
  {
    path: '/request_docs/:uuid',
    component: RequestDocs,
    is_private: true,
  }
]

export default routes